import React, { useEffect, useState, useCallback } from 'react';
import SoundManager from "../../../SoundManager";
import './ReactSound.css';

const ReactSound = (obj: any) => {
	const onEnded = () => {
		if(obj.onEnded) {
			obj.onEnded();
		}
	};
	useEffect(() => {
	}, [obj]);

	const [muted, setMuted] = useState(SoundManager.mutedAudio);

	const muteCallback = useCallback(
		() => {
			SoundManager.mutedAudio = !SoundManager.mutedAudio;
			setMuted((mute : boolean) => !mute);
		},
		[obj],
	);
	
	
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13){ //32 - spacebar, 36 - enter
			muteCallback();
		}
	};

	return (
		<div id={obj.id} className="sound-file-container">
			<div className="sound-file-container-ui-inner-container">
				{obj.src && <audio src={obj.src}
					muted={muted}
					controls={obj.controls}
					playsInline={obj.playsInline}
					onEnded={() => {
						onEnded();
					}}
					autoPlay={obj.autoPlay}>
				</audio>
				}
				<div className="mute-icon"
					aria-label="Toggle Mute"
					role="button"
					tabIndex={0}
					onClick={muteCallback}
					onKeyDown={onChangeValueKeyboard}>
					<img src={muted ? './assets/img/mute-icon.svg' : './assets/img/un-muted-icon.svg'} />
				</div>
			</div>
		</div>
	);
};

export default ReactSound;